var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { createBooleanFlag, createFeatureRelayClient, createIntegerFlag, createStringFlag, TokenType } from '@square/feature-relay-web-sdk';
export let FlagNames = /*#__PURE__*/function (FlagNames) {
  FlagNames["MULTIPASSUI_CALL_BROWSER_HOOK_BEFORE_LOGIN"] = "MULTIPASSUI_CALL_BROWSER_HOOK_BEFORE_LOGIN";
  FlagNames["ADA_ENABLED_LOCALE"] = "ADA_ENABLED_LOCALE";
  FlagNames["AUTHORIZATION_AUTHZ_ENGINES_USER_HARD_CHECK_ENABLED"] = "AUTHORIZATION_AUTHZ_ENGINES_USER_HARD_CHECK_ENABLED";
  FlagNames["MULTIPASSUI_USE_APP_SUBDOMAIN_LOGIN"] = "MULTIPASSUI_USE_APP_SUBDOMAIN_LOGIN";
  FlagNames["USE_SPLIT_LOGIN"] = "USE_SPLIT_LOGIN";
  FlagNames["PRELOAD_DASHBOARD_ASSETS"] = "PRELOAD_DASHBOARD_ASSETS";
  FlagNames["USE_TMX_TRACKING"] = "USE_TMX_TRACKING";
  FlagNames["EMPLOYEE_INVITATION_ERROR_LOGIN_BUTTON"] = "EMPLOYEE_INVITATION_ERROR_LOGIN_BUTTON";
  FlagNames["PASSKEYS_ENABLED"] = "PASSKEYS_ENABLED";
  FlagNames["ENABLE_DATADOG_RUM"] = "ENABLE_DATADOG_RUM";
  FlagNames["CDP_HEARTBEAT_INTERVAL_SECONDS"] = "CDP_HEARTBEAT_INTERVAL_SECONDS";
  FlagNames["ENABLE_PASSKEY_PROMO"] = "ENABLE_PASSKEY_PROMO";
  FlagNames["COMPLETE_LOGIN_ENABLED"] = "COMPLETE_LOGIN_ENABLED";
  FlagNames["SFF_SSO_NAV_LINK"] = "SFF_SSO_NAV_LINK";
  FlagNames["UISYSTEMS_MARKET_MONOCHROME"] = "UISYSTEMS_MARKET_MONOCHROME";
  FlagNames["MULTIPASSUI_LEARN_MORE_LINK_IN_LOGIN"] = "MULTIPASSUI_LEARN_MORE_LINK_IN_LOGIN";
  return FlagNames;
}({});
export const FLAG_CONFIGS = Object.freeze({
  MULTIPASSUI_CALL_BROWSER_HOOK_BEFORE_LOGIN: createBooleanFlag({
    key: 'multipassui-call-browser-hook-before-login',
    defaultValue: false
  }),
  ADA_ENABLED_LOCALE: createBooleanFlag({
    key: 'supportcenter-ada-enabled-in-locale',
    defaultValue: false
  }),
  AUTHORIZATION_AUTHZ_ENGINES_USER_HARD_CHECK_ENABLED: createBooleanFlag({
    key: 'authorization-authz-engines-user-hard-check-enabled',
    defaultValue: false
  }),
  MULTIPASSUI_USE_APP_SUBDOMAIN_LOGIN: createBooleanFlag({
    key: 'multipassui-use-app-subdomain-login',
    defaultValue: false
  }),
  USE_SPLIT_LOGIN: createBooleanFlag({
    key: 'multipass-use-split-login',
    defaultValue: false
  }),
  PRELOAD_DASHBOARD_ASSETS: createBooleanFlag({
    key: 'multipass-preload-dashboard-assets',
    defaultValue: false
  }),
  USE_TMX_TRACKING: createBooleanFlag({
    key: 'multipass-use-tmx-tracking',
    defaultValue: false
  }),
  EMPLOYEE_INVITATION_ERROR_LOGIN_BUTTON: createBooleanFlag({
    key: 'employee-invitation-error-login-button',
    defaultValue: false
  }),
  PASSKEYS_ENABLED: createBooleanFlag({
    key: 'multipass-passkeys-enabled',
    defaultValue: false
  }),
  ENABLE_DATADOG_RUM: createBooleanFlag({
    key: 'multipassui-enable-datadog-rum',
    defaultValue: false
  }),
  CDP_HEARTBEAT_INTERVAL_SECONDS: createIntegerFlag({
    key: 'multipass-cdp-heartbeat-interval-seconds',
    defaultValue: 5
  }),
  ENABLE_PASSKEY_PROMO: createBooleanFlag({
    key: 'multipassui-enable-passkey-promo',
    defaultValue: false
  }),
  COMPLETE_LOGIN_ENABLED: createBooleanFlag({
    key: 'multipassui-complete-login-enabled',
    defaultValue: false
  }),
  SFF_SSO_NAV_LINK: createBooleanFlag({
    key: 'sff-sso-nav-link',
    defaultValue: false
  }),
  UISYSTEMS_MARKET_MONOCHROME: createBooleanFlag({
    key: 'uisystems-market-monochrome',
    defaultValue: false
  }),
  MULTIPASSUI_LEARN_MORE_LINK_IN_LOGIN: createStringFlag({
    key: 'multipassui-learn-more-link-in-login',
    defaultValue: 'ineligible'
  })
});
const SINGLETON_TOKEN = 'SINGLETON';
let EmberMultipassFlagService = (_dec = service('ember-multipass-config'), _dec2 = service('ember-multipass-logging'), _class = class EmberMultipassFlagService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "multipassConfig", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _initializerDefineProperty(this, "cookies", _descriptor3, this);
    _defineProperty(this, "_flagValues", {});
  }
  /**
   * Create a http request to /1.0/features/get-flags.
   * Each request can send multiple flag names with one set of token and attributes.
   * If flags are based on different token/attributes, you need to initialize them separately
   * by calling initFlags multiple times.
   */
  async initFlags({
    names,
    token,
    userAttributes,
    tokenType
  }) {
    const userToken = {
      token,
      type: tokenType ?? TokenType.ANONYMOUS_VISITOR
    };
    const flagConfigs = {};
    names.forEach(name => {
      flagConfigs[name] = FLAG_CONFIGS[name];
    });
    const offlineMode = this.multipassConfig.environment === 'testing';
    const flagClient = createFeatureRelayClient({
      flagConfigs,
      userToken,
      userAttributes,
      offlineMode
    });
    try {
      await flagClient.loadFlags();
    } catch (e) {
      this.logger.sentryError(e);
    }
    names.forEach(name => {
      const flagConfig = flagConfigs[name];
      const flagValue = flagConfig ? flagClient.getFlagValue(flagConfig) : FLAG_CONFIGS[name].defaultValue;
      this._flagValues[name] = flagValue;
      const canStringifyFlagValue = typeof flagValue === 'object' && flagValue !== null;
      this.logger.addFeatureFlagTag(name, canStringifyFlagValue ? JSON.stringify(flagValue) : flagValue);
    });
  }
  getValue(name) {
    return this._flagValues[name] ?? FLAG_CONFIGS[name]?.defaultValue;
  }
  async loadAvtFlags() {
    const names = [FlagNames.MULTIPASSUI_USE_APP_SUBDOMAIN_LOGIN, FlagNames.USE_SPLIT_LOGIN, FlagNames.PRELOAD_DASHBOARD_ASSETS, FlagNames.USE_TMX_TRACKING, FlagNames.EMPLOYEE_INVITATION_ERROR_LOGIN_BUTTON, FlagNames.CDP_HEARTBEAT_INTERVAL_SECONDS, FlagNames.ENABLE_PASSKEY_PROMO, FlagNames.SFF_SSO_NAV_LINK, FlagNames.MULTIPASSUI_CALL_BROWSER_HOOK_BEFORE_LOGIN, FlagNames.UISYSTEMS_MARKET_MONOCHROME, FlagNames.MULTIPASSUI_LEARN_MORE_LINK_IN_LOGIN];
    const token = this.cookies.read('_savt');
    await this.initFlags({
      names,
      token
    });
    if (!token) {
      this.logger.sentryMessage('Missing avt cookie when loading feature flags');
    }
  }
  async loadPersonTokenFlags(personToken) {
    const names = [FlagNames.PASSKEYS_ENABLED, FlagNames.COMPLETE_LOGIN_ENABLED];
    await this.initFlags({
      names,
      token: personToken || SINGLETON_TOKEN,
      tokenType: TokenType.PERSON
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "multipassConfig", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cookies", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { EmberMultipassFlagService as default };